export const actionTypes = {
  SET_ACTIVELINE: "SET_ACTIVELINE",
  SET_FILTER: "SET_FILTER",
  SET_FILTER_DEFAULTS: "SET_FILTER_DEFAULTS",
  SET_LOADING: "SET_LOADING",
  SET_MODEL_DATE_ITEM: "SET_MODEL_DATE_ITEM",
  SET_STRENGTH_DATA: "SET_STRENGTH_DATA",
  SET_TABLE_VIEW_SELECTED_KEY: "SET_TABLE_VIEW_SELECTED_KEY",
  SET_VECTORSET2: "SET_VECTORSET2",
};
